import React from 'react';
import { useContext } from 'react';
import {AppContext} from '../App';
import { 
  MdCalendarToday, 
  MdLocationOn, 
  MdArrowForward, 
  MdGroup, 
  MdCelebration, 
  MdFavorite 
} from 'react-icons/md';

// KUINGIZA PICHA KWANZA KAMA VARIABLES KABISA (KAMA ULIVYOELEKEZA)
import communityDayImg from '../assets/banner1.png';
import agmMeetingImg from '../assets/image12.jpeg';
import endYearPartyImg from '../assets/image3.jpeg';

export default function HomeNews() {
  const appContext = useContext(AppContext);

  return (
    <section className="YcscExecutiveNewsSection position-relative py-5">
      <div className="container py-5">
        
        {/* EXECUTIVE HEADER */}
        <div className="row align-items-end mb-5">
          <div className="col-12 col-lg-7">
            <div className="d-flex align-items-center gap-2 mb-2">
              <span className="corporate-accent-dot"></span>
              <span className="corporate-sub-badge text-uppercase tracking-wider">Habari & Matukio Ya Chama</span>
            </div>
            <h2 className="corporate-news-title fw-bold text-dark m-0">
              Kumbukumbu za Maana na <br />
              <span className="text-corporate-primary">Matukio ya Kitaasisi</span>
            </h2>
          </div>
          <div className="col-12 col-lg-5 text-start text-lg-end mt-3 mt-lg-0">
            <p className="text-muted small-editorial-p m-0">
              Kupitia matukio yetu ya kila mwaka, tunajenga mshikamano thabiti wa kiuchumi na kijamii kulingana na kauli mbiu yetu ya <strong className="text-dark">"Mshikamano Daima"</strong>.
            </p>
          </div>
        </div>

        {/* PREMIUM BENTO GRID EDITORIAL */}
        <div className="row g-4">
          
          {/* TUKIO KUU: COMMUNITY DAY (THE ANCHOR HERO CARD) */}
          <div className="col-12 col-xl-7">
            <div className="premium-hero-news-card h-100 position-relative overflow-hidden d-flex flex-column justify-content-end">
              
              {/* Image rendered directly via inline style variable for clean production asset delivery */}
              <div 
                className="hero-news-bg-image" 
                style={{ backgroundImage: `url(${communityDayImg})` }}
              ></div>
              <div className="hero-news-dark-gradient"></div>
              
              {/* Premium Top Floating Tag */}
              <div className="premium-floating-tag d-flex align-items-center gap-2">
                <MdFavorite size={14} className="text-gold animate-pulse" />
                <span className="fw-bold tracking-wider">COMMUNITY EVENT</span>
              </div>

              {/* Content Area */}
              <div className="hero-news-meta-box position-relative z-3 p-4 p-md-5 text-white">
                <div className="d-flex align-items-center gap-3 mb-3 text-white-50 small font-monospace">
                  <span className="d-flex align-items-center gap-1">
                    <MdCalendarToday size={14} className="text-gold" /> Kila Mwezi wa Pili
                  </span>
                  <span className="d-flex align-items-center gap-1">
                    <MdLocationOn size={14} className="text-gold" /> Community Day
                  </span>
                </div>
                
                <h3 className="fw-bold text-white mb-3 hero-editorial-title">
                  Kurudisha kwa Jamii Wenye Uhitaji Kupitia YCSC Community Day
                </h3>

                <div className="pt-2">
                  <button onClick={() => {appContext.navTo({item: "view", subItem: "news", extraItem: "news-005"})}} className="btn btn-editorial-gold-link d-inline-flex align-items-center gap-2 fw-bold text-uppercase">
                    <span>Soma Zaidi Kuhusu Siku Hii</span>
                    <MdArrowForward size={16} className="btn-arrow-transition" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* MATUKIO MENGINE YA CHAMA (SIDE STACK GRID) */}
          <div className="col-12 col-xl-5">
            <div className="d-flex flex-column gap-4 h-100 justify-content-between">
              
              {/* TUKIO LA 2: ANNUAL GENERAL MEETING (AGM) */}
              <div className="premium-row-card p-4 d-flex flex-column flex-sm-row gap-4 align-items-center h-100">
                <div className="row-card-img-frame flex-shrink-0 overflow-hidden">
                  <img src={agmMeetingImg} alt="YCSC AGM Meeting" className="row-card-img-element" />
                </div>
                <div className="d-flex flex-column justify-content-between h-100 w-100">
                  <div>
                    <span className="row-card-mini-badge badge-blue mb-2 d-inline-block font-monospace">
                      <MdGroup size={12} /> ANNUAL MEETING
                    </span>
                    <h4 className="row-card-title text-dark fw-bold mb-2">
                      Mkutano Mkuu wa Chama (AGM)
                    </h4>
                    <p className="row-card-desc text-muted mb-0">
                      Mkutano mkuu unaofanyika mwisho wa mwaka kwa ajili ya kufanya tathmini, kupitisha sera mpya na kuweka mikakati thabiti ya ukuaji.
                    </p>
                  </div>
                  {/* <div className="pt-3 d-flex align-items-center justify-content-between border-top mt-3 text-muted small">
                    <span className="font-monospace fw-bold">Mwisho wa Mwaka</span>
                    <span className="text-corporate-primary fw-bold d-flex align-items-center gap-1 row-action-trigger">
                      Soma Agenda <MdArrowForward size={14} className="sub-arrow" />
                    </span>
                  </div> */}
                </div>
              </div>

              {/* TUKIO LA 3: END OF THE YEAR PARTY */}
              <div className="premium-row-card p-4 d-flex flex-column flex-sm-row gap-4 align-items-center h-100">
                <div className="row-card-img-frame flex-shrink-0 overflow-hidden">
                  <img src={endYearPartyImg} alt="YCSC End of Year Party" className="row-card-img-element" />
                </div>
                <div className="d-flex flex-column justify-content-between h-100 w-100">
                  <div>
                    <span className="row-card-mini-badge badge-gold mb-2 d-inline-block font-monospace">
                      <MdCelebration size={12} /> CELEBRATION
                    </span>
                    <h4 className="row-card-title text-dark fw-bold mb-2">
                      Sherehe za Mwisho wa Mwaka
                    </h4>
                    <p className="row-card-desc text-muted mb-0">
                      Siku ya kipekee ya (End of the Year Party) kwa ajili ya kufurahia mafanikio ya chama na kuimarisha undugu wa wanachama wote.
                    </p>
                  </div>
                  {/* <div className="pt-3 d-flex align-items-center justify-content-between border-top mt-3 text-muted small">
                    <span className="font-monospace fw-bold">Mwisho wa Mwaka</span>
                    <span className="text-gold-accent fw-bold d-flex align-items-center gap-1 row-action-trigger">
                      Angalia Picha <MdArrowForward size={14} className="sub-arrow" />
                    </span>
                  </div> */}
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
    </section>
  );
}